import {
	providerSchema,
	profileSchema,
	patientSchema,
	expenseSchema,
	bankAccountSchema,
	contributionSchema,
	customerSchema,
	referralSchema,
	employeeSchema
} from "../schemas"
import { axiosWrapper } from "../axios_old"

const _getSchema = ({ schema }) => {
	switch (schema) {
		case "profile":
			return profileSchema
		case "expense":
			return expenseSchema
		case "dependent":
			return patientSchema
		case "provider":
			return providerSchema
		case "bankAccount":
			return bankAccountSchema
		case "contribution":
			return contributionSchema
		case "recurringContribution":
			return contributionSchema
		case "customer":
			return customerSchema
		case "referral":
			return referralSchema
		case "employee":
			return employeeSchema
		default:
			return null
	}
}

const preparePayload = async (args) => {
	const { user, schema, data, url } = args
	const payload = {}

	const s = _getSchema({ schema })

	Object.entries(data).forEach(([key, val]) => {
		if (s[key] && val !== undefined) {
			const formattedVal = s[key](data[key])

			payload[key] = formattedVal
		}
	})
	if (Object.keys(payload).length > 0) {
		const res = await axiosWrapper("POST", url, payload, null, user.token)
		const newData = { ...data, ...payload, ...res.data }
		return newData
	}
	return {}
}

export default preparePayload
